interface Scripts {
  name: string;
  src: string;
}
export const ScriptStore: Scripts[] = [
  // { name: "modernizr", src: "assets/js/vendor/modernizr-2.8.3.min.js" },
  // { name: "jquery", src: "assets/js/vendor/jquery.min.js" },
  // { name: "bootstrap", src: "assets/js/bootstrap.bundle.min.js" },
  // { name: "plugins", src: "assets/js/plugins.js" },
  // { name: "ajax", src: "assets/js/ajax-mail.js" },
  { name: "main", src: "assets/js/main.js" },
];
